// constants
import { InvoicesActionTypes } from "./constants";

//Action
export interface InvoicesActionType {
  type:
    | InvoicesActionTypes.GET_LIST_INVOICES_ERROR
    | InvoicesActionTypes.GET_LIST_INVOICES_SUCCESS
    | InvoicesActionTypes.GET_LIST_INVOICES
    | InvoicesActionTypes.GET_INVOICE
    | InvoicesActionTypes.GET_INVOICE_SUCCESS
    | InvoicesActionTypes.GET_INVOICE_ERROR
    | InvoicesActionTypes.UPDATE_STATUS_INVOICE
    | InvoicesActionTypes.UPDATE_STATUS_INVOICE_SUCCESS
    | InvoicesActionTypes.UPDATE_STATUS_INVOICE_ERROR
    | InvoicesActionTypes.UPDATE_INVOICE
    | InvoicesActionTypes.UPDATE_INVOICE_SUCCESS
    | InvoicesActionTypes.UPDATE_INVOICE_ERROR;
  payload: {} | string;
}

//Interfaces
interface InvoicesData {
  iteam?: any[];
  total?: number;
  country?: string;
  keyword?: string;
  limit?: number;
  skip?: number;
  owner?: string;
}

interface GetInvoice {
  id: string;
}

interface UpdateStatusInvoiceData {
  id: string;
  status?: string;
}

interface InvoiceUpdate {
  expeditionFees: number;
  otherFees: number;
}

//Invoice_List
export const InvoicesGetListSuccess = (
  actionType: string,
  data: InvoicesData | {}
): InvoicesActionType => ({
  type: InvoicesActionTypes.GET_LIST_INVOICES_SUCCESS,
  payload: { actionType, data },
});

export const InvoicesGetListError = (
  actionType: string,
  error: string
): InvoicesActionType => ({
  type: InvoicesActionTypes.GET_LIST_INVOICES_ERROR,
  payload: { actionType, error },
});

export const getInvoicesList = (
  keyword: string = "",
  limit: number = 10,
  skip: number = 0,
  owner: string = "",
  country: string = "ic",
  status: string = "",
  boutique: string = ""
): InvoicesActionType => ({
  type: InvoicesActionTypes.GET_LIST_INVOICES,
  payload: { keyword, limit, skip, owner, country, status, boutique },
});

//Update Status Invoice
export const updateStatusInvoiceSuccess = (
  actionType: string,
  data: UpdateStatusInvoiceData | {}
): InvoicesActionType => ({
  type: InvoicesActionTypes.UPDATE_STATUS_INVOICE_SUCCESS,
  payload: { actionType, data },
});
export const updateStatusInvoiceError = (
  actionType: string,
  error: string
): InvoicesActionType => ({
  type: InvoicesActionTypes.UPDATE_STATUS_INVOICE_ERROR,
  payload: { actionType, error },
});

export const updateStatusInvoice = (
  id: string,
  status?: string
): InvoicesActionType => ({
  type: InvoicesActionTypes.UPDATE_STATUS_INVOICE,
  payload: { id, status },
});

//GET Invoice

export const getInvoiceSuccess = (
  actionType: string,
  data: GetInvoice | {}
): InvoicesActionType => ({
  type: InvoicesActionTypes.GET_INVOICE_SUCCESS,
  payload: { actionType, data },
});
export const getInvoiceError = (
  actionType: string,
  error: string
): InvoicesActionType => ({
  type: InvoicesActionTypes.GET_INVOICE_ERROR,
  payload: { actionType, error },
});

export const getInvoice = (id: string): InvoicesActionType => ({
  type: InvoicesActionTypes.GET_INVOICE,
  payload: { id },
});

export const updateInvoiceSuccess = (
  actionType: string,
  data: InvoiceUpdate | {}
): InvoicesActionType => ({
  type: InvoicesActionTypes.UPDATE_INVOICE_SUCCESS,
  payload: { actionType, data },
});
export const updateInvoiceError = (
  actionType: string,
  error: string
): InvoicesActionType => ({
  type: InvoicesActionTypes.UPDATE_INVOICE_ERROR,
  payload: { actionType, error },
});

export const updateInvoice = (
  id: string,
  data: InvoiceUpdate
): InvoicesActionType => ({
  type: InvoicesActionTypes.UPDATE_INVOICE,
  payload: { id, ...data },
});
